const capitalizeFirstLetter = text => (text ? text[0].toUpperCase() + text.slice(1) : '');
export default capitalizeFirstLetter;
